/**
 * Attribution sidebar configuration
 */
export default {
  pathPrefix: 'attribution',
  items: [
    {
      label: 'Widgets',
      href: '/attribution/widgets',
      icon: 'fa-solid fa-code',
      activePath: 'attribution/widgets'
    },
    {
      label: 'Sites',
      href: '/attribution/sites',
      icon: 'fa-solid fa-globe',
      activePath: 'attribution/sites'
    }
  ]
}
